import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { ContactEven, ContactFiona } from 'embed/constants'
import { formattedPhoneNumber } from 'embed/utils'
import { css } from 'emotion'
import { Brand } from '@evenfinancial/even-ts-static'
import * as React from 'react'
import { useAppSelector } from 'embed/hooks'

const styles = require('./styles')

export interface Props {
  brand?: Brand
}

const EvenCreditDisclosure = () => (
  <>
    <p>
      We do not charge any fee or cost to submit a credit card request on engine.tech. The actual rate depends on
      several factors determined by the credit card provider such as your credit score, usage and history. If you are
      offered a credit card, you will have the opportunity to review the final offer made by the provider, and to accept
      the credit card agreement made directly between you and the credit card provider.
    </p>
    <p>
      All rates, fees, and terms are presented without guarantee and are subject to change pursuant to each provider's
      discretion and may not be available in all states. There is no guarantee you will be approved or qualify for the
      advertised rates, fees, or terms presented. This website does not include all financial companies or all offers
      that may be available to you. You should read the credit card issuers personal terms and conditions, as well as
      any disclosures, in full before proceeding for any credit card. Requirements, fees, discounts or other terms and
      conditions will vary by credit card issuer. The actual credit card rate you may receive depends on the benefits
      requested, as well as your credit score, usage, and history.
    </p>
    <p>
      Please note, our credit card partners' privacy policy and security practices may differ from Engine by MoneyLion
      standards. Engine by MoneyLion assumes no responsibility, nor does it control, endorse or guarantee any aspect of
      your use of the linked site. All rates, fees, and terms are presented without guarantee and are subject to change
      pursuant to each provider's discretion and may not be available in all states or for all types of credit cards.
      There is no guarantee you will be approved or qualify for the advertised rates, fees, or terms presented. This
      website does not include all credit card companies or all available credit card offers that may be available to
      you. Certain products and services may not be available in all U.S. States.
    </p>
    <p>
      Representative Example: If you have a $5,000 balance remaining at a 15% APR. Your end of day balance would be
      $5,000 after the first day., Assuming no purchases or payments, your balance at the end of the second day would be
      $5000, plus $2.05 in interest that accrued on the previous day’s balance ($5000*(0.15/365)). This would repeat
      every day until the end of the billing period. If there are no fees or other charges monthly repayment may be
      $5,061.50
    </p>
    <p>
      Annual Percentage Rate (APR) Disclosure: The Annual Percentage Rate is a measure of the cost of credit, expressed
      as a nominal yearly rate. It relates the amount and timing of value received by the consumer to the amount and
      timing of payments made. Generally interest is assessed on a daily basis. This means that an issuer will determine
      how much to charge you on a given day by multiplying the balance at the end of that day by your APR/365. These
      interest charges will then become part of your balance the next day and will themselves incur interest.
    </p>
    <p>
      By law, the credit card issuer must show you the APR before you enter into a consumer credit transaction. States
      have laws that may limit the APR that the issuer can charge you. Rates will vary and your rate, line amount, and
      default term depend on maintaining a qualifying credit score, your credit usage history, requested amount, and
      other factors.We recommend that you read the issuers personal terms and conditions in full before proceeding with
      a credit card.
    </p>
    <p>
      Requirements, or other terms and conditions will vary by provider. We recommend that you read the providers
      personal terms and conditions, as well as any disclosures, in full before proceeding with any credit card.
    </p>
    <p>
      Engine by MoneyLion is the technology platform powering financial services online. Engine by MoneyLion's API
      enables its partners to connect their users with real-time decisions and personalized offers and rates from
      premium financial services providers. Engine by MoneyLion offices are located at 50 West 23rd Street, Suite 700,
      New York, NY 10010, Telephone number: {formattedPhoneNumber(ContactEven.Phone)}. This site is directed at, and
      made available to, persons in the continental U.S., Alaska and Hawaii only.
    </p>
  </>
)

const FionaCreditDisclosure = () => (
  <>
    <p>
      We do not charge any fee or cost to submit a credit card request on www.fiona.com. The actual rate depends on
      several factors determined by the credit card provider such as your credit score, usage and history. If you are
      offered a credit card, you will have the opportunity to review the final offer made by the provider, and to accept
      the credit card agreement made directly between you and the credit card provider.
    </p>
    <p>
      All rates, fees, and terms are presented without guarantee and are subject to change pursuant to each provider's
      discretion and may not be available in all states. There is no guarantee you will be approved or qualify for the
      advertised rates, fees, or terms presented. This website does not include all financial companies or all offers
      that may be available to you. You should read the credit card issuers personal terms and conditions, as well as
      any disclosures, in full before proceeding for any credit card. Requirements, fees, discounts or other terms and
      conditions will vary by credit card issuer. The actual credit card rate you may receive depends on the benefits
      requested, as well as your credit score, usage, and history.
    </p>
    <p>
      Please note, our credit card partners' privacy policy and security practices may differ from Engine by MoneyLion /
      Fiona standards. Engine by MoneyLion / Fiona assumes no responsibility, nor does it control, endorse or guarantee
      any aspect of your use of the linked site. All rates, fees, and terms are presented without guarantee and are
      subject to change pursuant to each provider's discretion and may not be available in all states or for all types
      of credit cards. There is no guarantee you will be approved or qualify for the advertised rates, fees, or terms
      presented. This website does not include all credit card companies or all available credit card offers that may be
      available to you. Certain products and services may not be available in all U.S. States.
    </p>
    <p>
      Representative Example: If you have a $5,000 balance remaining at a 15% APR. Your end of day balance would be
      $5,000 after the first day., Assuming no purchases or payments, your balance at the end of the second day would be
      $5000, plus $2.05 in interest that accrued on the previous day’s balance ($5000*(0.15/365)). This would repeat
      every day until the end of the billing period. If there are no fees or other charges monthly repayment may be
      $5,061.50
    </p>
    <p>
      Annual Percentage Rate (APR) Disclosure: The Annual Percentage Rate is a measure of the cost of credit, expressed
      as a nominal yearly rate. It relates the amount and timing of value received by the consumer to the amount and
      timing of payments made. Generally interest is assessed on a daily basis. This means that an issuer will determine
      how much to charge you on a given day by multiplying the balance at the end of that day by your APR/365. These
      interest charges will then become part of your balance the next day and will themselves incur interest.
    </p>
    <p>
      By law, the credit card issuer must show you the APR before you enter into a consumer credit transaction. States
      have laws that may limit the APR that the issuer can charge you. Rates will vary and your rate, line amount, and
      default term depend on maintaining a qualifying credit score, your credit usage history, requested amount, and
      other factors.We recommend that you read the issuers personal terms and conditions in full before proceeding with
      a credit card.
    </p>
    <p>
      Requirements, or other terms and conditions will vary by provider. We recommend that you read the providers
      personal terms and conditions, as well as any disclosures, in full before proceeding with any credit card.
    </p>
    <p>
      Engine by MoneyLion is the technology platform powering financial services online. Engine by MoneyLion's API
      enables its partners to connect their users with real-time decisions and personalized offers and rates from
      premium financial services providers. Engine by MoneyLion offices are located at 50 West 23rd Street, Suite 700,
      New York, NY 10010, Telephone number: {formattedPhoneNumber(ContactFiona.Phone)}. This site is directed at, and
      made available to, persons in the continental U.S., Alaska and Hawaii only.
    </p>
  </>
)

export const CreditDisclosure: React.FunctionComponent<Props> = ({ brand }) => (
  <ThemeConsumer>
    {({ fontFamilySecondary }) => (
      <div
        className={classnames(
          css`
            font-family: ${fontFamilySecondary};
          `,
          styles.CreditCardDisclosureGroup,
        )}
      >
        {brand === Brand.Fiona ? <FionaCreditDisclosure /> : <EvenCreditDisclosure />}
      </div>
    )}
  </ThemeConsumer>
)

export const PlainCreditDisclosure = () => {
  const brand = useAppSelector((state) => state.config.brand)

  return (
    <>
      <p>
        <strong>Additional Information</strong>
      </p>
      {brand === Brand.Fiona ? <FionaCreditDisclosure /> : <EvenCreditDisclosure />}
    </>
  )
}
